module.exports = __webpack_public_path__ + "img/icon_report_empty_logo_3.4098d5ff.png";